// extracted by mini-css-extract-plugin
export default {"numberColumnTitle":"styles_numberColumnTitle__GnRZp","tableCell":"styles_tableCell__gpF7w","labelTable":"styles_labelTable__Dl1As","statisticTable":"styles_statisticTable__b7OF2"};